import { render, staticRenderFns } from "./addModifierModal.vue?vue&type=template&id=f4aa422c&scoped=true"
import script from "./addModifierModal.vue?vue&type=script&lang=js"
export * from "./addModifierModal.vue?vue&type=script&lang=js"
import style0 from "./addModifierModal.vue?vue&type=style&index=0&id=f4aa422c&prod&lang=scss&scoped=true"
import style1 from "./addModifierModal.vue?vue&type=style&index=1&id=f4aa422c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aa422c",
  null
  
)

export default component.exports